import React from 'react'
import { Heading, Flex, Spinner, Box } from '@theme-ui/components'
import LazyLoad from 'react-lazyload'
import backgroundStylesGradient from '../../helpers/backgroundStylesGradient'
import componentOptionsSelector from '../../helpers/componentOptionsSelector'
import TextBodySelector from '../General/TextBodySelector'
import titleSelector from '../../helpers/titleSelector'
import AnimationSelector from '../Animation/AnimationSelector'
import MultipleLinksSelector from '../Links/MultipleLinksSelector'
export default function AboutSectionV1({
  businessData,
  options,
  variantName,
  poweredImages,
  locations,
  locationIndex,
  allGeneral
}) {
  const { desc, city } = businessData

  const storyId = options.storyId?.[locationIndex]
  const storyTag = options.storyTag?.[locationIndex]

  const {
    titles,
    subtitles,
    texts,
    textType,
    ctaLinks,
    ctaNames,
    links,
    images,
    restrictCharacters,
    backgroundImages,
    backgroundGradient,
    animation,
    order,
    containerStyles
  } = componentOptionsSelector(options, locationIndex, storyId, allGeneral, storyTag)

  const isMultiLocationSite = locations.length > 1
  // chooses variantName
  const variant = variantName ? variantName : 'contentSectionV1'

  // creates container and parse string styles from config file to object
  const styles = containerStyles ? JSON.parse(containerStyles) : {}

  // this is needed to when using stories as hardcoded uses backgroundImages option where stories uses images property
  const imageSelector = backgroundImages ? backgroundImages : images ? images : ''

  // build backgroundImageStyle object with dyanmic gradent options with poweredImagesSelector
  const backgroundStyles =
    backgroundImages || (images && images?.length !== 0)
      ? backgroundStylesGradient(
          Array.isArray(imageSelector) ? imageSelector[0] : imageSelector,
          backgroundGradient,
          poweredImages,
          locationIndex
        )
      : ''

  const noContent = !titles && !subtitles && !texts && !ctaLinks && !ctaNames && !images && !backgroundImages

  if (!noContent) {
    return (
      <Box sx={{ order: order ? order : 'none' }}>
        <AnimationSelector animation={animation}>
          <LazyLoad
            offset={600}
            debounce={300}
            placeholder={
              <Flex
                sx={{
                  justifyContent: 'center',
                  alignItems: 'center',
                  minHeight: '300px'
                }}
              >
                <Spinner />
              </Flex>
            }
          >
            <Flex
              variant={`${variant}.container`}
              className="container"
              sx={{
                backgroundImage: backgroundStyles,
                ...styles
              }}
            >
              <Flex variant={`${variant}.section`} className="section">
                {subtitles ? (
                  <Heading variant={`${variant}.subtitle`} className="subtitle">
                    {subtitles}
                  </Heading>
                ) : (
                  ''
                )}

                {titles && titleSelector(titles) ? (
                  <Heading as="h2" variant={`${variant}.title`} className="title">
                    {titleSelector(titles)}
                  </Heading>
                ) : (
                  ''
                )}

                {texts ? (
                  <TextBodySelector
                    variantName={`${variantName}`}
                    texts={texts}
                    textType={textType}
                    restrictCharacters={restrictCharacters}
                    desc={desc}
                  />
                ) : (
                  ''
                )}
                {links?.length > 0 ? (
                  <MultipleLinksSelector
                    links={links}
                    variant={`${variantName}`}
                    isMultiLocationSite={isMultiLocationSite}
                    city={city}
                  />
                ) : null}
              </Flex>
            </Flex>
          </LazyLoad>
        </AnimationSelector>
      </Box>
    )
  } else {
    return ''
  }
}
